<div *ngIf="isLoading" class="loading">
  <mat-progress-spinner
    color="primary"
    mode="indeterminate"
  ></mat-progress-spinner>
</div>

<con-page-layout>
  <div fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="16px">
    <h2>{{ 'active_folders' | translate }}</h2>
    <div fxFlex></div>
  </div>
  <div class="sub-title">{{ 'folders_subtitle' | translate }}</div>

  <div fxLayout="row wrap" style="justify-content: space-between">
    <div fxLayoutAlign="start center" fxLayoutGap="16px">
        <div>
            <ng-container>
            <br />
            <a mat-raised-button 
            color="primary"
            [disabled]="!isActiveFoldersViews()"
            (click)="cleanupFolders()">
            {{ 'cleanup_folder' | translate }}
            </a>
            </ng-container>
        </div>
    </div>
    <div fxLayout="row" fxLayoutAlign="end center">
        <div fxLayoutGap="16px">
        <ng-container>
            <a mat-raised-button color="primary" (click)="refreshFolders()">
                <mat-icon>cached</mat-icon> {{ 're-evaluate' | translate }}
            </a>
        </ng-container>
        </div>
    </div>
  </div>

  <con-page-layout-content fxLayout="column" fxLayoutGap="16px">
    <br />
    <div class="matTable-container mat-elevation-z8" *ngIf=" (media.isActive('lg') || media.isActive('xl') || media.isActive('md'))">
    <mat-table matSort #table [dataSource]="dataSource" class="mat-elevation-z8">

        <!-- Checkbox Column -->
        <ng-container matColumnDef="select">
        <mat-header-cell fxFlex="5%" *matHeaderCellDef>
            <mat-checkbox (change)="$event ? masterToggle() : null"
                        [checked]="selection.hasValue() && isAllSelected()"
                        [indeterminate]="selection.hasValue() && !isAllSelected()">
            </mat-checkbox>
        </mat-header-cell>
        <mat-cell fxFlex="5%" *matCellDef="let row">
            <mat-checkbox (click)="$event.stopPropagation()"
                        [disabled]="isCheckBoxView(row)"
                        (change)="$event ? selection.toggle(row) : null"
                        [checked]="selection.isSelected(row)">
            </mat-checkbox>
        </mat-cell>
        </ng-container>

        <!-- Account Name Column -->
        <ng-container cdkColumnDef="account_name">
        <mat-header-cell fxFlex="20%" *cdkHeaderCellDef mat-sort-header> {{ 'account_name' | translate }} </mat-header-cell>
        <mat-cell fxFlex="20%" *cdkCellDef="let folder"> {{folder.account_name}} </mat-cell>
        </ng-container>

        <!-- Folder Name Column -->
        <ng-container cdkColumnDef="folder_name">
        <mat-header-cell fxFlex="20%" *cdkHeaderCellDef mat-sort-header> {{ 'folder_name' | translate }} </mat-header-cell>
        <mat-cell fxFlex="20%" *cdkCellDef="let folder"> {{folder.asset_name}} </mat-cell>
        </ng-container>

        <!-- Services Column -->
        <ng-container cdkColumnDef="services">
        <mat-header-cell fxFlex="60%" *cdkHeaderCellDef mat-sort-header> {{ 'services' | translate }} </mat-header-cell>
        <mat-cell fxFlex="60%" *cdkCellDef="let folder"> {{folder.services_data}} </mat-cell>
        </ng-container>

        <mat-header-row *cdkHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
        <mat-row *cdkRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>
    </div>
    <br />

    <!-- Mobile view -->
    <mat-list *ngIf="!(media.isActive('lg') || media.isActive('xl') || media.isActive('md'))">

    <!-- Select All -->
    <mat-list-item *ngIf="isContributor">
        <mat-checkbox (change)="$event ? masterToggle() : null"
                    [checked]="selection.hasValue() && isAllSelected()"
                    [indeterminate]="selection.hasValue() && !isAllSelected()">
        Select All
        </mat-checkbox>
    </mat-list-item>

    <mat-divider></mat-divider>

    <!-- Folders -->
    <ng-container *ngFor="let folder of dataSource.data">

        <mat-list-item class="folder-item">

        <!-- Checkbox -->
        <mat-checkbox (click)="$event.stopPropagation()"
                        [disabled]="isCheckBoxView(folder)"
                        (change)="$event ? selection.toggle(folder) : null"
                        [checked]="selection.isSelected(folder)">
        </mat-checkbox>

        <!-- Content -->
        <div class="folder-content">

            <div class="folder-header">
            <div class="folder-name">
                {{folder.asset_name}}
            </div>

            <button mat-icon-button
                    [matMenuTriggerFor]="mobileMenu"
                    (click)="$event.stopPropagation()">
                <mat-icon>more_vert</mat-icon>
            </button>

            <mat-menu #mobileMenu="matMenu">
                <button mat-menu-item *ngIf="isAssignTraining(folder)"
                        (click)="assignTraining(folder)">
                {{ 'assign_training' | translate }}
                </button>
            </mat-menu>
            </div>

            <div class="folder-info">
            <div><b>Account:</b> {{folder.account_name}}</div>
            <div><b>Folder:</b> {{folder.asset_name}}</div>
            <div><b>Services:</b> {{folder.services}}</div>
            </div>

        </div>
        </mat-list-item>
        <mat-divider></mat-divider>
    </ng-container>
    </mat-list>

  </con-page-layout-content>
</con-page-layout>